import React, { useState } from "react";
import moment from "moment-timezone";
import { List, Button, Tooltip } from "antd";
import { withTranslation } from "react-i18next";
import * as R from "ramda";

import Element from "../../../../../../../../components/structure/Element";
import Tag from "../../../../../../../../components/feedback/Tag";
import Message from "../../../../../../../../components/feedback/Message";

import styled from "styled-components/macro";

const Row = styled(List.Item)`
  border-bottom: none !important;

  &:not(:first-child) {
    border-top: 1px solid #e8e8e8;
  }
  .ant-list-item-meta-description {
    font-size: 12px;
  }
`;

const SubList = styled(List)`
  padding-left: 12px !important;
  border-left: 1px solid ${({ theme }) => theme["@primary"]};
`;

const TheDay = styled.div`
  display: flex;
  margin-left: 10px;
  align-items: center;
  font-size: 12px;
  color: #8e8e8e;
`;

const Item = ({ t, actions, room, ...props }) => {
  const [toggled, toggle] = useState();
  const candidates = R.propOr([], "candidates", room);

  return (
    <>
      <Row
        data-test="room"
        actions={[
          <Tooltip title={t("opportunity:process.rooms.participants")}>
            <Button
              ghost={!toggled}
              type="primary"
              icon="eye"
              onClick={() => toggle(!toggled)}
            />
          </Tooltip>,
          ...actions
        ]}
        {...props}
      >
        <List.Item.Meta
          title={
            <Element display="flex">
              <Element marginRight={6}>{room.name}</Element>
              <Tag>{R.length(candidates)} candidatos</Tag>
              <TheDay>
                {`${t("opportunity:process.rooms.theDay")} ${moment(
                  room.start
                ).format("LL")}`}
              </TheDay>
            </Element>
          }
          description={`${t("opportunity:process.rooms.theTime")} ${moment(
            room.start
          ).format("HH:mm")}hs - ${t(
            "opportunity:process.rooms.theDuration"
          )}: ${moment(room.start).from(room.end, true)}`}
        />
      </Row>
      {toggled && (
        <Element paddingBottom={12}>
          {R.isEmpty(candidates) ? (
            <Message type="primary-lighter">
              {t("opportunity:process.rooms.room.empty")}
            </Message>
          ) : (
            <SubList size="small">
              {candidates.map(candidate => (
                <Row>
                  <List.Item.Meta
                    title={R.propOr(
                      `${candidate.first} ${candidate.last}`,
                      "fullname",
                      candidate
                    )}
                    description={R.propOr(
                      R.propOr("-", "emailAddress", candidate),
                      "email",
                      candidate
                    )}
                  />
                </Row>
              ))}
            </SubList>
          )}
        </Element>
      )}
    </>
  );
};

export default withTranslation(["opportunity"])(Item);
